// External libraries
import gql from 'graphql-tag';
import {
  CART_AMOUNTS_FRAGMENT,
  CART_ITEMS_FRAGMENT,
  SHIPPING_METHODS_FRAGMENT,
} from '../fragments';

export const CHECKOUT_SESSION_QUERY = gql`
  query CheckoutSessionQuery(
    $token: String!
    $isSntSupported: Boolean = false
  ) {
    checkoutSession(token: $token) {
      cart {
        ...CartAmounts
        ...CartItems
        ...ShippingMethods @include(if: $isSntSupported)
      }
    }
  }

  ${CART_AMOUNTS_FRAGMENT}
  ${CART_ITEMS_FRAGMENT}
  ${SHIPPING_METHODS_FRAGMENT}
`;
